import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isSupportedOS as isDesktopOS } from "@tv4/avod-web-player-device-capabilities";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { useClientCallback } from "../providers/ClientCallbackContext";
import { usePlayerState } from "../providers/CoreProvider";
import { useLayoutSize } from "../providers/LayoutProvider";
import { useMetadata } from "../providers/MetadataProvider";
import { useTranslations } from "../providers/TranslationsProvider";
import { LayoutSize } from "../util/device";
import ContentRatings from "./ContentRatings";
export const Metadata = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ $isFullscreen }) => (isDesktopOS() && $isFullscreen ? 0.2 : 1)}em;

  overflow: hidden;
  transition: 0.5s ease-out;
  font-size: ${({ $size }) => [LayoutSize.SMALLEST, LayoutSize.SMALL].includes($size) ? 0.7 : 1}em;
`;
export const Title = styled.h1 `
  padding: 0 1em 0 0;
  margin: 0;
  display: -webkit-box;
  width: 100%;
  font-size: ${({ $size }) => [LayoutSize.SMALLEST, LayoutSize.SMALL].includes($size) ? 1.5 : 1.8}em;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: ${({ $size }) => [LayoutSize.SMALLEST, LayoutSize.SMALL].includes($size) ? 2 : 3};
  -webkit-box-orient: vertical;
`;
export const Subtitle = styled.h2 `
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 1.125em;
  font-style: normal;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.7;
`;
const CurrentProgramMetaData = (props) => {
    const { asset } = useMetadata();
    const { isFullscreen } = usePlayerState();
    const translations = useTranslations();
    const size = useLayoutSize();
    const contentRating = asset?.contentRating;
    const isClip = !!asset?.isClip;
    const [titleToRender, setTitleToRender] = useState("");
    const [subtitleToRender, setSubtitleToRender] = useState("");
    const { getContentMetadata } = useClientCallback();
    useEffect(() => {
        if (!asset) {
            // Reset the title and subtitle when there is no asset (for external sources)
            setTitleToRender("");
            setSubtitleToRender("");
            return;
        }
        let aborted = false;
        if (getContentMetadata) {
            getContentMetadata(asset.id)
                .then(({ title, subtitle }) => {
                if (aborted)
                    return;
                setTitleToRender(title);
                setSubtitleToRender(subtitle);
            })
                .catch((_) => {
                // noop
            });
        }
        else {
            setTitleToRender((isClip && asset.title) || asset.seriesTitle || "");
            let subHeading = "";
            if (asset) {
                if (asset.seasonNumber) {
                    subHeading += `${translations("program_metadata__season")} ${asset.seasonNumber}`;
                }
                if (asset.seasonNumber && asset.episodeNumber) {
                    subHeading += " - ";
                }
                if (asset.episodeNumber) {
                    subHeading += `${translations("program_metadata__episode")} ${asset.episodeNumber}`;
                }
            }
            setSubtitleToRender(subHeading);
        }
        return () => {
            aborted = true;
        };
    }, [asset, getContentMetadata, isClip, translations]);
    if (props.$hidden) {
        return null;
    }
    return (_jsx(Metadata, { "$isFullscreen": isFullscreen, "$size": size, style: props.style, children: _jsxs("div", { "aria-flowto": "player-header-controls", children: [titleToRender && _jsx(Title, { "$size": size, children: titleToRender }), subtitleToRender && _jsx(Subtitle, { children: subtitleToRender }), contentRating && _jsx(ContentRatings, {})] }) }));
};
export default CurrentProgramMetaData;
